// import React, { useContext } from 'react'
// import { ShopContext } from '../context/ShopContext'
// import Title from './Title';

// const CartTotal = () => {

//     const {currency,delivery_fee,getCartAmount} = useContext(ShopContext);

//   return (
//     <div className='w-full'>
//       <div className='text-2xl'>
//         <Title text1={'CART'} text2={'TOTALS'} />
//       </div>

//       <div className='flex flex-col gap-2 mt-2 text-sm'>
//             <div className='flex justify-between'>
//                 <p>Subtotal</p>
//                 <p>{currency} {getCartAmount()}.00</p>
//             </div>
//             <hr />
//             <div className='flex justify-between'>
//                 <p>Shipping Fee</p>
//                 <p>{currency} {delivery_fee}.00</p>
//             </div>
//             <hr />
//             <div className='flex justify-between'>
//                 <b>Total(Including Tax)</b>
//                 <b>{currency} {getCartAmount() === 0 ? 0 : getCartAmount() + delivery_fee}.00</b>
//             </div>
//       </div>
//     </div>
//   )
// }

// export default CartTotal

//working

// const CartTotal = () => {
//   const { currency, delivery_fee, getCartAmount } = useContext(ShopContext);
//   const { totalAmount, discountAmount } = getCartAmount();
//   const finalAmount = totalAmount - discountAmount + (totalAmount === 0 ? 0 : delivery_fee);

//   return (
//       <div className='w-full'>
//           <div className='text-2xl'>
//               <Title text1={'CART'} text2={'TOTALS'} />
//           </div>

//           <div className='flex flex-col gap-2 mt-2 text-sm'>
//               <div className='flex justify-between'>
//                   <p>Subtotal</p>
//                   <p>{currency} {totalAmount}.00</p>
//               </div>
//               <hr />
//               <div className='flex justify-between'>
//                   <p>Discount</p>
//                   <p>- {currency} {discountAmount}.00</p>
//               </div>
//               <hr />
//               <div className='flex justify-between'>
//                   <p>Shipping Fee</p>
//                   <p>{currency} {delivery_fee}.00</p>
//               </div>
//               <hr />
//               <div className='flex justify-between'>
//                   <b>Total (Including Tax)</b>
//                   <b>{currency} {finalAmount}.00</b>
//               </div>
//           </div>
//       </div>
//   );
// };

// export default CartTotal;

// import React, { useContext, useState } from "react";
// import { ShopContext } from "../context/ShopContext";
// import Title from "./Title";

// const CartTotal = () => {
//   const { currency, delivery_fee, getCartAmount } = useContext(ShopContext);
//   const [couponCode, setCouponCode] = useState("");
//   const [discount, setDiscount] = useState(0);
//   const [error, setError] = useState("");

//   const applyCoupon = async () => {
//     setError("");
//     try {
//       const response = await fetch("/api/coupons/apply", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ code: couponCode }),
//       });

//       const data = await response.json();
//       if (data.success) {
//         setDiscount(data.discount);
//       } else {
//         setError(data.message);
//       }
//     } catch (error) {
//       setError("Something went wrong");
//     }
//   };

//   const subtotal = getCartAmount();
//   const total = subtotal === 0 ? 0 : subtotal + delivery_fee - (subtotal * discount) / 100;

//   return (
//     <div className="w-full">
//       <div className="text-2xl">
//         <Title text1={"CART"} text2={"TOTALS"} />
//       </div>

//       <div className="flex flex-col gap-2 mt-2 text-sm">
//         <div className="flex justify-between">
//           <p>Subtotal</p>
//           <p>{currency} {subtotal}.00</p>
//         </div>
//         <hr />
//         <div className="flex justify-between">
//           <p>Shipping Fee</p>
//           <p>{currency} {delivery_fee}.00</p>
//         </div>
//         <hr />

//         <div className="flex flex-col mt-4">
//           <input
//             type="text"
//             placeholder="Enter Coupon Code"
//             value={couponCode}
//             onChange={(e) => setCouponCode(e.target.value)}
//             className="border px-4 py-2 rounded-md"
//           />
//           <button
//             onClick={applyCoupon}
//             className="mt-2 px-4 py-2 bg-green-500 text-white rounded-md"
//           >
//             Apply Coupon
//           </button>
//           {error && <p className="text-red-500 mt-2">{error}</p>}
//         </div>

//         {discount > 0 && (
//           <>
//             <hr />
//             <div className="flex justify-between">
//               <p>Discount ({discount}%)</p>
//               <p>-{currency} {(subtotal * discount) / 100}.00</p>
//             </div>
//           </>
//         )}

//         <hr />
//         <div className="flex justify-between">
//           <b>Total</b>
//           <b>{currency} {total.toFixed(2)}</b>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CartTotal;

import React, { useContext, useState } from "react";
import { ShopContext } from "../context/ShopContext";
import Title from "./Title";
import { useLocation } from "react-router-dom";

const CartTotal = () => {
  const { currency, delivery_fee, getCartAmount, coupon, setCoupon } =
    useContext(ShopContext);
  const { totalAmount, discountAmount } = getCartAmount();
  const finalAmount =
    totalAmount - discountAmount + (totalAmount === 0 ? 0 : delivery_fee);

  const [inputCoupon, setInputCoupon] = useState("");
  const location = useLocation();

  const handleApplyCoupon = () => {
    if (inputCoupon.trim().toLowerCase() === "flat10") {
      setCoupon("Flat10");
    } else if (inputCoupon.trim().toLowerCase() === "buy2") {
      setCoupon("BUY2");
    } else {
      setCoupon("");
      alert("Invalid Coupon");
    }
  };

  const isPlaceOrderPage = location.pathname === "/place-order";

  return (
    <div className="w-full">
      <div className="text-2xl">
        <Title text1={"CART"} text2={"TOTALS"} />
      </div>

      <div className="flex flex-col gap-2 mt-2 text-sm">
        <div className="flex justify-between">
          <p>Subtotal</p>
          <p>
            {currency} {totalAmount}.00
          </p>
        </div>
        <hr />
        <div className="flex justify-between">
          <p>Discount</p>
          <p>
            - {currency} {discountAmount}.00
          </p>
        </div>
        <hr />
        <div className="flex justify-between">
          <p>Shipping Fee</p>
          <p>
            {currency} {delivery_fee}.00
          </p>
        </div>
        <hr />
        <div className="flex justify-between">
          <b>Total (Including Tax)</b>
          <b>
            {currency} {finalAmount}.00
          </b>
        </div>

        {/* Coupon Section */}
        {!isPlaceOrderPage ? (
          <div className="mt-4">
            <input
              type="text"
              placeholder="Enter Coupon Code"
              value={inputCoupon}
              onChange={(e) => setInputCoupon(e.target.value)}
              className="p-2 border rounded w-full mt-2"
            />
            <button
              onClick={handleApplyCoupon}
              className="mt-2 bg-orange-500 text-white px-4 py-2 rounded"
            >
              Apply Coupon
            </button>
            {coupon && (
              <p className="text-green-500 mt-1">
                Coupon <b>{coupon}</b> applied.
              </p>
            )}
          </div>
        ) : (
          coupon && (
            <p className="text-green-500 mt-4">
              Coupon <b>{coupon}</b> applied.
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default CartTotal;

